import BasePerimeter from './basePerimeter';

export default new BasePerimeter({
  purpose: 'complaints',
  govern: {
    'can createComplaint': function createComplaint() {
      return this.isCRM() || this.isAdmin();
    },
    'can manageOperators': function manageOperators() {
      return this.isAdmin();
    },
    'can manageUsers': function manageUsers() {
      return this.isAdmin();
    },
    'can manageCategories': function manageCategories() {
      return this.isAdmin();
    },
    'can viewFinance': function viewFinance() {
      return this.isAdmin() || this.isFDP();
    },
    'can viewAll': function viewAll() {
      return this.isERR();
    },
  },
});



// WEBPACK FOOTER //
// ./src/perimeters/complaintsPerimeter.js